"use client";

import React, { useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Plane } from "lucide-react";
const destinations = [{
  name: "Isztambul",
  code: "IST",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/dest_istanbul.png"
}, {
  name: "Dubaj",
  code: "DXB",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/dest_dubai.png"
}, {
  name: "Moszkva",
  code: "MOW",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/dest_moscow.png"
}, {
  name: "Las Vegas",
  code: "LAS",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/dest_las_vegas.png"
}, {
  name: "New York",
  code: "NYC",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/dest_new_york.png"
}, {
  name: "London",
  code: "LON",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/dest_london.png"
}];
export default function FlightSearchWidget() {
  useEffect(() => {
    (window as any).TPWL_EXTRA = {
      currency: "HUF",
      trs: "12345",
      shmarker: "12345",
      marker: "12345",
      domain: "travelpayouts.com",
      locale: "hu",
      link_color: "var(--primary)"
    };
    const script = document.createElement("script");
    script.src = "https://c.travelpayouts.com/weedle/widget.js";
    script.async = true;
    script.charset = "utf-8";
    const container = document.getElementById("weedle-elements-container");
    if (container) {
      container.appendChild(script);
    }
    return () => {
      if (container && container.contains(script)) {
        container.removeChild(script);
      }
    };
  }, []);
  return <section id="flight-search-widget" className="bg-background text-foreground min-h-screen flex flex-col font-sans">
      {}
      <div className="hidden" aria-hidden="true">
        <meta property="og:title" content="Repülőjegy Kereső - Az utazásod itt kezdődik" />
        <meta property="og:description" content="Keressen és foglaljon olcsó repülőjegyeket a világ minden tájára." />
        <meta property="og:image" content="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/flight_search_og.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Repülőjegy Kereső" />
        <meta name="twitter:description" content="Találja meg a legjobb repülőjegy ajánlatokat gyorsan és egyszerűen." />
      </div>

      {}
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-md border-b border-border py-4 px-6 shadow-sm">
        <div className="container mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 transition-opacity hover:opacity-80">
            <Plane className="size-7 text-primary" />
            <span className="font-default text-xl font-bold tracking-tight hidden sm:inline-block">AeroSearch</span>
          </Link>
          <h1 className="font-default text-lg sm:text-xl font-semibold text-foreground">
            Az utazásod itt kezdődik
          </h1>
        </div>
      </header>

      {}
      <main className="flex-1 container mx-auto px-4 py-12 md:py-20 space-y-20">
        
        {}
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-8 space-y-4">
            <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tight">
              Hová szeretne utazni?
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Hasonlítsa össze több száz légitársaság ajánlatát, és találja meg a legkedvezőbb repülőjegyeket másodpercek alatt.
            </p>
          </div>
          
          <div id="weedle-elements-container" className="w-full rounded-2xl shadow-xl bg-card border border-border p-2 sm:p-6 min-h-[300px] flex items-center justify-center relative overflow-hidden" style={{
          '--tpwl-main-text': 'var(--foreground)',
          '--tpwl-background': 'var(--card)',
          '--tpwl-accent-color': 'var(--primary)',
          '--tpwl-border-color': 'var(--border)',
          '--tpwl-button-background': 'var(--primary)',
          '--tpwl-button-text': 'var(--primary-foreground)',
          '--tpwl-border-radius': 'var(--radius)'
        } as React.CSSProperties}>
            {}
            <div className="absolute inset-0 flex items-center justify-center bg-card z-[-1]">
              <div className="animate-pulse flex flex-col items-center gap-4">
                <Plane className="size-12 text-muted-foreground/50 animate-bounce" />
                <p className="text-muted-foreground font-medium">Kereső betöltése...</p>
              </div>
            </div>
          </div>
        </div>

        {}
        <section className="max-w-6xl mx-auto">
          <div className="flex items-center justify-between mb-10">
            <h2 className="font-default text-3xl font-bold tracking-tight">Népszerű Úti Célok</h2>
            <Link to="/FlightsPage" className="text-primary font-medium hover:underline hidden sm:block">
              Összes megtekintése &rarr;
            </Link>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {destinations.map((dest, i) => <Card key={dest.code} data-index={i} className="overflow-hidden group cursor-pointer hover:shadow-xl transition-all duration-300 border-border/50 hover:border-primary/30">
                <AspectRatio ratio={4 / 3} className="overflow-hidden">
                  <img src={dest.img} data-wvc-srcset={`${dest.img}-wvc-srcset`} data-wvc-sizes={`${dest.img}-wvc-sizes`} alt={`Repülőjegyek ide: ${dest.name}`} className="object-cover w-full h-full group-hover:scale-110 transition-transform duration-700 ease-in-out" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="absolute bottom-0 left-0 p-6 w-full flex justify-between items-end">
                    <div>
                      <h3 className="font-default text-2xl font-bold text-white mb-1">{dest.name}</h3>
                      <p className="text-white/80 text-sm font-medium">Közvetlen járatok elérhetők</p>
                    </div>
                    <span className="bg-primary/90 backdrop-blur-sm text-primary-foreground font-mono px-3 py-1.5 rounded-md text-sm font-bold shadow-sm">
                      {dest.code}
                    </span>
                  </div>
                </AspectRatio>
              </Card>)}
          </div>
          
          <div className="mt-8 text-center sm:hidden">
            <Link to="/FlightsPage" className="text-primary font-medium hover:underline">
              Összes megtekintése &rarr;
            </Link>
          </div>
        </section>
      </main>

      {}
      <footer className="bg-muted/50 border-t border-border py-12 px-6 mt-auto">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2 opacity-80">
            <Plane className="size-5 text-foreground" />
            <span className="font-default text-lg font-bold tracking-tight">AeroSearch</span>
          </div>
          
          <p className="text-muted-foreground text-sm text-center md:text-left">
            © {new Date().getFullYear()} Minden jog fenntartva.
          </p>
          
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="/ContactPage" className="text-sm text-muted-foreground hover:text-foreground transition-colors font-medium">
              Kapcsolat
            </Link>
            <Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors font-medium">
              Adatvédelmi irányelvek
            </Link>
            <Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors font-medium">
              Felhasználási feltételek
            </Link>
          </div>
        </div>
      </footer>
    </section>;
}